import { BaseButton } from '../BaseButton/BaseButton';

export const BaseButtonLink = (props) => {
  const { children, ...rest } = props;

  return (
    <BaseButton link {...rest}>
      {children}
    </BaseButton>
  );
};

export default BaseButtonLink;
